export const server_features = {
  chat: {
    text: 'Chat',
    value: 'chat',
  },
  transcription: {
    text: 'Transcription',
    value: 'transcription',
  },
  segmentation: {
    text: 'Segmentation',
    value: 'segmentation',
  },
}